// Author liang gang qiang
// Date 2021-11-27 11:30:12

class MintalMesPrdProductionInfo {
constructor({
        id = null,
        prdResultId = '',
        qtOutput = '',
        qtSendToYl = '',
        qtOutside = '',
        qtPowderRate = '',
        qtGradeAvg = '',
        qtInventoryOutput = '',
        qtInventory = '',
        qtOpeningInventory = '',
        ylOutCount = '',
        ylOutput = '',
        ylCrRate = '',
        ylCrRateAvg = '',
        ylFirstGradeRate = '',
        ylCrcl3Rate = '',
        ylAlkalinity = '',
        ylSlagCount = '',
        ylCr2o3Input = '',
        ylRecycleRate = '',
        qualifiedRate = '',
        operationRate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.prdResultId = prdResultId;
    this.qtOutput = qtOutput;
    this.qtSendToYl = qtSendToYl;
    this.qtOutside = qtOutside;
    this.qtPowderRate = qtPowderRate;
    this.qtGradeAvg = qtGradeAvg;
    this.qtInventoryOutput = qtInventoryOutput;
    this.qtInventory = qtInventory;
    this.qtOpeningInventory = qtOpeningInventory;
    this.ylOutCount = ylOutCount;
    this.ylOutput = ylOutput;
    this.ylCrRate = ylCrRate;
    this.ylCrRateAvg = ylCrRateAvg;
    this.ylFirstGradeRate = ylFirstGradeRate;
    this.ylCrcl3Rate = ylCrcl3Rate;
    this.ylAlkalinity = ylAlkalinity;
    this.ylSlagCount = ylSlagCount;
    this.ylCr2o3Input = ylCr2o3Input;
    this.ylRecycleRate = ylRecycleRate;
    this.qualifiedRate = qualifiedRate;
    this.operationRate = operationRate;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesPrdProductionInfo();
}

const pelletizingVoConfigs = [
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtSendToYl',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtSendToYl',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtOutside',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtOutside',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtPowderRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtPowderRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtGradeAvg',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtGradeAvg',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtInventoryOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtInventoryOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtInventory',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtInventory',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtOpeningInventory',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtOpeningInventory',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualifiedRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qualifiedRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.operationRate',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ]
    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtSendToYl',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtSendToYl',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtOutside',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtOutside',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtPowderRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtPowderRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtGradeAvg',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtGradeAvg',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtInventoryOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtInventoryOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtInventory',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtInventory',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qtOpeningInventory',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qtOpeningInventory',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylOutCount',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylOutCount',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylCrRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylCrRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylCrRateAvg',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylCrRateAvg',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylFirstGradeRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylFirstGradeRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylCrcl3Rate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylCrcl3Rate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylAlkalinity',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylAlkalinity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylSlagCount',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylSlagCount',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylCr2o3Input',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylCr2o3Input',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylRecycleRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylRecycleRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualifiedRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qualifiedRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.operationRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}
const smeltingVoConfigs = [
        {
        key: 'locationName',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'planDay',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.planDay',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'shiftPlanCode',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.shiftPlanCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'shiftName',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.shiftName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylOutCount',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylOutCount',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylOutput',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylCrRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylCrRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylCrRateAvg',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylCrRateAvg',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylFirstGradeRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylFirstGradeRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylCrcl3Rate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylCrcl3Rate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylAlkalinity',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylAlkalinity',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylSlagCount',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylSlagCount',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylCr2o3Input',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylCr2o3Input',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'ylRecycleRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.ylRecycleRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'qualifiedRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.qualifiedRate',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'operationRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.grid.operationRate',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ]

const filter = {
    idFilter : '',
    idListFilter : [],
    prdResultIdFilter : '',
    qtOutputFilter : '',
    qtSendToYlFilter : '',
    qtOutsideFilter : '',
    qtPowderRateFilter : '',
    qtGradeAvgFilter : '',
    qtInventoryOutputFilter : '',
    qtInventoryFilter : '',
    qtOpeningInventoryFilter : '',
    ylOutCountFilter : '',
    ylOutputFilter : '',
    ylCrRateFilter : '',
    ylCrRateAvgFilter : '',
    ylFirstGradeRateFilter : '',
    ylCrcl3RateFilter : '',
    ylAlkalinityFilter : '',
    ylSlagCountFilter : '',
    ylCr2o3InputFilter : '',
    ylRecycleRateFilter : '',
    qualifiedRateFilter : '',
    operationRateFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const pelletizingFilterConfigs = [
        {
        key: 'prdResultIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.prdResultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'qtOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtSendToYlFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtSendToYl',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtOutsideFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtOutside',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtPowderRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtPowderRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtGradeAvgFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtGradeAvg',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtInventoryOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtInventoryOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtInventoryFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtInventory',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtOpeningInventoryFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtOpeningInventory',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualifiedRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qualifiedRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'operationRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.operationRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];
const filterConfigs = [
        {
        key: 'prdResultIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.prdResultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'qtOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtSendToYlFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtSendToYl',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtOutsideFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtOutside',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtPowderRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtPowderRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtGradeAvgFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtGradeAvg',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtInventoryOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtInventoryOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtInventoryFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtInventory',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtOpeningInventoryFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qtOpeningInventory',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylOutCountFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylOutCount',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylCrRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrRateAvgFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylCrRateAvg',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylFirstGradeRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylFirstGradeRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrcl3RateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylCrcl3Rate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylAlkalinityFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylAlkalinity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylSlagCountFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylSlagCount',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCr2o3InputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylCr2o3Input',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylRecycleRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylRecycleRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualifiedRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qualifiedRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'operationRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.operationRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];
const smeltingFilterConfigs = [
        {
        key: 'prdResultIdFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.prdResultId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'ylOutCountFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylOutCount',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylOutputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylOutput',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylCrRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrRateAvgFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylCrRateAvg',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylFirstGradeRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylFirstGradeRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrcl3RateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylCrcl3Rate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylAlkalinityFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylAlkalinity',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylSlagCountFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylSlagCount',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCr2o3InputFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylCr2o3Input',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylRecycleRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.ylRecycleRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualifiedRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.qualifiedRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'operationRateFilter',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.filter.operationRate',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];


    const pelletizingEntityConfigs = [
        {
        key: 'prdResultId',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.prdResultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'qtOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtOutput',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtSendToYl',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtSendToYl',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtOutside',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtOutside',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtPowderRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtPowderRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtGradeAvg',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtGradeAvg',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtInventoryOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtInventoryOutput',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtInventory',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtInventory',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtOpeningInventory',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtOpeningInventory',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualifiedRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qualifiedRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'operationRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.operationRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
]
    const entityFormConfigs = [
        {
        key: 'prdResultId',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.prdResultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'qtOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtOutput',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtSendToYl',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtSendToYl',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtOutside',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtOutside',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtPowderRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtPowderRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtGradeAvg',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtGradeAvg',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtInventoryOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtInventoryOutput',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtInventory',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtInventory',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qtOpeningInventory',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qtOpeningInventory',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylOutCount',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylOutCount',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylOutput',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylCrRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrRateAvg',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylCrRateAvg',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylFirstGradeRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylFirstGradeRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrcl3Rate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylCrcl3Rate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylAlkalinity',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylAlkalinity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylSlagCount',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylSlagCount',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCr2o3Input',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylCr2o3Input',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylRecycleRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylRecycleRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualifiedRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qualifiedRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'operationRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.operationRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]
    const smeltingEntityConfigs = [
        {
        key: 'prdResultId',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.prdResultId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'mintalMesPrdProductionResult'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'ylOutCount',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylOutCount',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylOutput',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylOutput',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylCrRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrRateAvg',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylCrRateAvg',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylFirstGradeRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylFirstGradeRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCrcl3Rate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylCrcl3Rate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylAlkalinity',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylAlkalinity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylSlagCount',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylSlagCount',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylCr2o3Input',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylCr2o3Input',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'ylRecycleRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.ylRecycleRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'qualifiedRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.qualifiedRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'operationRate',
        label: 'label.mintal.prd.mintalMesPrdProductionInfo.entity.operationRate',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
]

export {MintalMesPrdProductionInfo, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, pelletizingFilterConfigs, filterConfigs, smeltingFilterConfigs
, pelletizingEntityConfigs, smeltingEntityConfigs
, pelletizingVoConfigs, smeltingVoConfigs
}
